import { render, staticRenderFns } from "./PersonalDataStep.vue?vue&type=template&id=4d345f94&"
import script from "./PersonalDataStep.vue?vue&type=script&lang=js&"
export * from "./PersonalDataStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports